import * as actionTypes from '../action-types'

export const updateUserType = payload => {
  return {
    type: actionTypes.UPDATE_USER_TYPE,
    payload
  }
}

export const updateUser = data => {
  return {
    type: actionTypes.UPDATE_USER,
    payload: data
  };
}


// WEBPACK FOOTER //
// ./src/redux-store/actions/user-actions.js